import { render, staticRenderFns } from "./layout-employee.vue?vue&type=template&id=2c8592f5"
import script from "./layout-employee.vue?vue&type=script&lang=js"
export * from "./layout-employee.vue?vue&type=script&lang=js"
import style0 from "./layout-employee.vue?vue&type=style&index=0&id=2c8592f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports